/**
 * Competência é exibida como mês/ano no formulário; a API recebe YYYY-MM-DD (dia 1 do mês).
 */

/** Normaliza qualquer competência da API para o 1º dia do mesmo mês. */
export function competenceDateToApiFirstOfMonth(iso: string | null | undefined): string {
  if (iso == null || !String(iso).trim()) return "";
  const t = String(iso).trim();
  const m = t.match(/^(\d{4})-(\d{2})(?:-(\d{2}))?/);
  if (!m) return t;
  return `${m[1]}-${m[2]}-01`;
}

/** Valor para `<input type="month" />` a partir do estado (YYYY-MM-DD ou vazio). */
export function competenceDateToMonthValue(apiDate: string): string {
  if (!apiDate.trim()) return "";
  const match = apiDate.trim().match(/^(\d{4}-\d{2})/);
  return match ? match[1] : "";
}

/** Converte o valor do seletor mês/ano (YYYY-MM) em data para a API. */
export function monthValueToCompetenceApiDate(monthValue: string): string {
  const v = monthValue.trim();
  if (!v) return "";
  return /^\d{4}-\d{2}$/.test(v) ? `${v}-01` : v;
}
